export const aqiMeterRegistry = [
    {
        meter_id: 1125,
        meter_name: "Cold Room 1",
        location: "Cold Storage Area",
        ranges: {
            temperature: [16, 20],
            humidity: [70, 90],
            co: [300, 1200],          // ppm
            tvoc: [50, 300],          // ppb
            formaldehyde: [0.01, 0.06], // mg/m3
            pm2:[50,100],
            pm10:[50,100],
        },
    },
    {
        meter_id: 1124,
        meter_name: "Cold Room 2",
        location: "Cold Storage Area",
        ranges: {
            temperature: [10, 14],
            humidity: [75, 92],
            co: [250, 1000],
            tvoc: [40, 250],
            formaldehyde: [0.01, 0.05],
            pm2:[50,100],
            pm10:[50,100],
        },
    },
    {
        meter_id: 1116,
        meter_name: "Cold Room 3",
        location: "Cold Storage Area",
        ranges: {
            temperature: [17, 21],
            humidity: [65, 85],
            co: [200, 900],
            tvoc: [30, 220],
            formaldehyde: [0.01, 0.04],
            pm2:[50,100],
            pm10:[50,100],
        },
    },
];
